import { ReactNode } from 'react';
import { Box, Tooltip } from '@parspec/pixel';

interface IListItem {
    imageDimension?: { width: string };
    imageUrl?: string;
    listTitle?: string;
    Icon?: ReactNode;
    onClick?: () => void;
    isSelected?: boolean;
    open?: boolean;
}

export default function ListItem({ listTitle, Icon, onClick, isSelected }: IListItem) {
    return (
        <Tooltip dashboardTooltip title={listTitle} placement="right">
            <Box
                onClick={onClick}
                sx={{
                    backgroundColor: isSelected ? '#334155' : null,
                    borderRadius: isSelected ? "6px" : null,
                    '&:hover': {
                        bgcolor: '#334155',
                        borderRadius: "6px",
                        cursor: 'pointer'
                    }
                }}
                display={'flex'}
                p={3}
                justifyContent={'center'}
            >
                <Box p="1px" display="flex">{Icon}</Box>
            </Box>
        </Tooltip>
    );
}